import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { AxiosResponse } from 'axios';
import { ProfilDTO } from '@/modules/Account/store/state';

class AccountService {

    public async getSocieteIds(filtreSitePublie?: boolean): Promise<any> {
        return http.get(Routes.AccountRoutes.GetSocieteIds(), {params: {filtreSitePublie: filtreSitePublie}});
    }

    public async getInformations(): Promise<AxiosResponse<ProfilDTO>> {
        return http.get(Routes.AccountRoutes.GetInformations());
    }

    public async saveMobilePhone(phoneNumber: string): Promise<AxiosResponse> {
        return http.put(Routes.AccountRoutes.PutTelephonePortable(), {phoneNumber});
    }

    public async savePhone(phoneNumber: string): Promise<AxiosResponse> {
        return http.put(Routes.AccountRoutes.PutTelephoneFixe(), {phoneNumber});
    }
    public async saveMdp(mdp: string): Promise<AxiosResponse> {
        return http.put(Routes.AccountRoutes.PutMdp(), {mdp});
    }
    public async demanderSuppressionCompte(): Promise<AxiosResponse> {
        return http.post(Routes.AccountRoutes.PostDemandeSuppressionCompte());
    }

}

export default new AccountService();
